module.exports = __webpack_public_path__ + "img/sample-02.aefb9666.png";